import { IHydratedOption } from "shared/interfaces/Catalog.interface";
import { IOrderItem } from "shared/interfaces/Order.interface";

export default (option: IHydratedOption, currentDish: IOrderItem): number => {
  return currentDish.modifiers
    .filter((item) => item.group_id === option.id)
    .reduce((acc, item) => acc + item.quantity, 0);
};
